"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PUSH_PREFERENCES = void 0;
exports.DEFAULT_PUSH_PREFERENCES = {
    comment_event_board: true,
    comment_event_others: true,
    comment_feedpost_all: true,
    event_1_hours: true,
    event_24_hours: true,
    notes_received: true,
};
//# sourceMappingURL=pushpreferences.js.map